export const TAGS_LOADING_ERROR = "Failed to load the list of space tags.";
